import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'

import { StyledButtonList, StyledButtonListItem, StyledButton, StyledTitle } from './styled'
import { Photos, Photos360, Video, Content } from './Sections'

const Portfolio = (props) => {

    const tabs = {
        photo: 'photo',
        video: 'video',
        photo360: 'photo360'
    }
    const [selectedTab, setSelectedTab] = React.useState('photo')
    const handleTabChange = (tabName) => setSelectedTab(tabName)

    return (
        <Container fluid>
            <Row>
                <Col
                    lg={3}
                    className='d-lg-flex d-none justify-content-center align-items-centerd-flex justify-content-center align-items-center'
                >
                    <StyledButtonList>
                        <StyledButtonListItem>
                            <StyledButton color='primary' onClick={() => handleTabChange(tabs.photo)}>
                                <i class="fa icon-camera"></i>
                                <span>Fotos</span>
                            </StyledButton>
                        </StyledButtonListItem>
                        <StyledButtonListItem>
                            <StyledButton color='primary' onClick={() => handleTabChange(tabs.video)}>
                                <i class="fa icon-player"></i>
                                <span>Vídeos</span>
                            </StyledButton>
                        </StyledButtonListItem>
                        {
                            props?.portfolio?.photos_360?.length
                            ? (
                                <StyledButtonListItem>
                                    <StyledButton color='primary' onClick={() => handleTabChange(tabs.photo360)}>
                                        <i class="fa icon-360"></i>
                                        <span>Fotos 360</span>
                                    </StyledButton>
                                </StyledButtonListItem>
                            )
                            : ''
                        }
                    </StyledButtonList>
                </Col>

                

                <Col 
                    lg={{
                        span: 8,
                        offset: 1
                    }}
                    xs={12}
                >
                    {
                        selectedTab === tabs.photo ? <Photos photos={props.portfolio.photos} /> : ''
                    }
                    
                    {
                        selectedTab === tabs.video ? <Video video={props.portfolio.youtube} /> : ''
                    }

                    {
                        selectedTab === tabs.photo360 ? <Photos360 index={props.index} photos_360={props.portfolio.photos_360}/> : ''
                    }
                </Col>

                <Col
                    xs={12}
                    className='d-lg-none d-flex justify-content-center align-items-centerd-flex justify-content-center align-items-center'
                >
                    <StyledButtonList>
                        <StyledButtonListItem>
                            <StyledButton color='primary' onClick={() => handleTabChange(tabs.photo)}>
                                <i class="fa icon-camera"></i>
                                <span className='d-none d-sm-block'>Fotos</span>
                            </StyledButton>
                        </StyledButtonListItem>
                        <StyledButtonListItem>
                            <StyledButton color='primary' onClick={() => handleTabChange(tabs.video)}>
                                <i class="fa icon-player"></i>
                                <span className='d-none d-sm-block'>Vídeos</span>
                            </StyledButton>
                        </StyledButtonListItem>
                        <StyledButtonListItem>
                            <StyledButton color='primary' onClick={() => handleTabChange(tabs.photo360)}>
                                <i class="fa icon-360"></i>
                                <span className='d-none d-sm-block'>Fotos 360</span>
                            </StyledButton>
                        </StyledButtonListItem>
                    </StyledButtonList>
                </Col>

            </Row>

            <Row>
                <Col
                    lg={{
                        offset: 4,
                        span: 8
                    }}
                    xs={12}
                >
                    <Content content={props.portfolio.content}/>
                </Col>
            </Row>
        </Container>
    )
}

export default Portfolio